import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromCurrentOrganization from '../reducers/current-organization.reducer';
import {State} from '../reducers/current-organization.reducer';
import {Organization} from '../../../services/api/organizations/models/organization.model';

export const selectCurrentOrganizationState = createFeatureSelector<State>(
  fromCurrentOrganization.currentOrganizationFeatureKey
);

export const getCurrentOrganizationRecord = createSelector(
  selectCurrentOrganizationState,
  (state: State): Organization => state.record
);

export const getCurrentOrganizationLoaded = createSelector(
  selectCurrentOrganizationState,
  (state: State): boolean => state.loaded
);

export const getCurrentOrganizationLoading = createSelector(
  selectCurrentOrganizationState,
  (state: State): boolean => state.loading
);

export const getCurrentOrganizationError = createSelector(
  selectCurrentOrganizationState,
  (state: State): unknown => state.error
);
